import Clock from 'assets/icons/clock.svg';
import { AuctionTime } from 'domain/entities/PropertyEntity';
import { useEffect, useState } from 'react';

const BACKGROUND_GREEN = 'rgba(25, 47, 81, 1)';
const BACKGROUND_RED = 'rgba(181, 42, 33, 1)';

export const BadgeTiming = (props: { auctionTime: AuctionTime; auctionStatus: string }) => {
    const [value, setValue] = useState<string>();
    const [color, setColor] = useState<string>(BACKGROUND_GREEN);

    useEffect(() => {
        if (!props.auctionTime) return;
        const valueString = props.auctionTime?.d
            ? props.auctionTime?.d + '日'
            : props.auctionTime?.h + '時間';
        const colorString = props.auctionTime?.d ? BACKGROUND_GREEN : BACKGROUND_RED;
        setValue(valueString);
        setColor(colorString);
    }, [props.auctionTime]);

    return !props?.auctionTime ? (
        ['STANDBY', 'OPEN', 'SUSPEND', 'CLOSE'].includes(props.auctionStatus) ? (
            <div
                className="badge-timing"
                style={{
                    display: 'flex',
                    alignContent: 'center',
                    backgroundColor: BACKGROUND_GREEN,
                }}
            >
                <img alt="" src={Clock} />
                <div style={{ marginLeft: 4 }}>入札一時停止中</div>
            </div>
        ) : (
            <></>
        )
    ) : (
        <div
            className="badge-timing"
            style={{ display: 'flex', alignContent: 'center', backgroundColor: color }}
        >
            <img alt="" src={Clock} />
            <div style={{ marginLeft: 4 }}>あと{value ?? ''}</div>
        </div>
    );
};
